export const CHAT_ALLOWED_FILE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "pdf",
  "docx",
  "txt",
  "csv",
  "md",
  "json",
];

export const CHAT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const CHAT_MAX_PROMPT_LENGTH = 1000;

export const CHAT_SUGGESTION_KEYS = [
  { textKey: "chat.suggestion_1", icon: "chart" },
  { textKey: "chat.suggestion_2", icon: "email" },
  { textKey: "chat.suggestion_3", icon: "document" },
  { textKey: "chat.suggestion_4", icon: "analytics" },
];

export const getThreadUuid = (thread) =>
  thread?.thread_id || thread?.threadId || thread?.uuid || thread?.id || "";

// Floating launcher state. The side is a PHYSICAL side ("left" | "right"), so
// it stays where the user dropped it when the page switches language.
export const CHAT_LAUNCHER_SIDE_KEY = "chatLauncherSide";
// Written when the user hides the launcher, cleared on every page load: hiding
// lasts for the session in memory, never across a reload.
export const CHAT_LAUNCHER_HIDDEN_KEY = "chatLauncherHidden";
